import React, { useEffect, useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LeadRecordPicker from '../../Leads/components/LeadRecordPicker';
import {
  appModalActionsSx,
  appModalCloseButtonSx,
  appModalHeaderDividerSx,
  appModalPaperSx,
  appModalPrimaryButtonSx,
  appModalSecondaryButtonSx,
  appModalTitleBarSx,
  appModalTitleSx,
} from '../../Components/appModalChrome.styles';
import { LEADS_TEXT_SECONDARY } from '../../Leads/components/leadsUi.styles';
import { META_CREATE_KINDS } from '../metaCreate';
import MetaCreateCampaignDialog from './MetaCreateCampaignDialog';

/**
 * «Crear campaña» desde el panel Campañas: primero se elige UNA unidad o lote (el buscador de
 * Leads, solo `user_lot` / `cad_parcel`: el lote de catastro queda como encabezado de sus UF),
 * se ve elegida como chip y «Continuar» abre `MetaCreateCampaignDialog` con ese registro (el
 * mismo de la ficha: pide sus opciones y retoma el pendiente si lo hay). Solo el dueño en su
 * espacio (`metaCreateAccess`), así que el buscador va sin `owner_user_id`. Mismo chrome que
 * `MetaLinkUnitsDialog`. Los registros sin compartir no se filtran: el modal de crear lo explica.
 *
 * @param {{ open: boolean, onClose: () => void,
 *   onChanged?: (info: { kind: string, result?: object }) => void }} props
 */
export default function MetaCreatePickRecordDialog({ open, onClose, onChanged = null }) {
  const [picked, setPicked] = useState([]);
  const [record, setRecord] = useState(null);

  useEffect(() => {
    if (!open) return;
    setPicked([]);
    setRecord(null);
  }, [open]);

  if (!open) return null;

  if (record) {
    return (
      <MetaCreateCampaignDialog
        open
        itemKind={record.itemKind}
        recordId={record.id}
        onClose={onClose}
        onChanged={onChanged}
      />
    );
  }

  const choice = picked[0] || null;
  const handleSubmit = (e) => {
    e.preventDefault();
    if (choice) setRecord(choice);
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
        noValidate: true,
        sx: { ...appModalPaperSx, width: 'min(520px, 95vw)', maxWidth: '520px', height: 'auto', maxHeight: 'min(90vh, 680px)' },
        'data-testid': 'meta-create-pick-dialog',
      }}
      aria-labelledby="meta-create-pick-title"
    >
      <DialogTitle id="meta-create-pick-title" component="div" sx={appModalTitleBarSx}>
        <Typography component="h2" sx={appModalTitleSx}>Crear campaña</Typography>
        <IconButton size="small" onClick={onClose} aria-label="Cerrar" sx={appModalCloseButtonSx}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>
      <Divider sx={appModalHeaderDividerSx} />
      <DialogContent sx={{ px: '20px', pt: 2, pb: 0, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography sx={{ fontSize: '13px', color: LEADS_TEXT_SECONDARY }}>
          Elegí la unidad o el lote que va a promocionar. Se crea en pausa y queda vinculada.
        </Typography>
        <LeadRecordPicker
          value={picked}
          onChange={setPicked}
          max={1}
          itemKinds={META_CREATE_KINDS}
          label="Unidad o lote"
          autoFocus
        />
      </DialogContent>
      <DialogActions sx={appModalActionsSx}>
        <Button variant="outlined" onClick={onClose} sx={appModalSecondaryButtonSx}>Cancelar</Button>
        <Button
          type="submit"
          variant="contained"
          disabled={!choice}
          sx={appModalPrimaryButtonSx}
          data-testid="meta-create-pick-continue"
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
